export function isValidLngLat(lng: number, lat: number): boolean {
  if (lng === undefined || lng > 180 || lng < -180) {
    return false;
  }

  if (lat === undefined || lat > 90 || lat < -90) {
    return false;
  }

  return true;
}
